import React from "react";
import SingletonEditor from "./SingletonEditor";

const fields = [
  { key: "eyebrow", label: "Eyebrow Tagline", help: "Small text above the headline" },
  { key: "headline_line1", label: "Headline Line 1" },
  { key: "headline_line2", label: "Headline Line 2", help: "This line is colored gold" },
  { key: "subheadline", label: "Sub-headline", type: "textarea", rows: 3 },
  { key: "cta_primary_label", label: "Primary Button Text" },
  { key: "cta_secondary_label", label: "Secondary Button Text" },
  { key: "video_url", label: "Hero Video URL", help: "Use /media/hero.mp4 (default), or upload a new video in Media Library and paste its public URL" },
  { key: "poster_url", label: "Hero Poster Image URL (optional)", help: "Shown while video loads" },
  { key: "stat1_value", label: "Stat 1 Value" },
  { key: "stat1_label", label: "Stat 1 Label" },
  { key: "stat2_value", label: "Stat 2 Value" },
  { key: "stat2_label", label: "Stat 2 Label" },
  { key: "stat3_value", label: "Stat 3 Value" },
  { key: "stat3_label", label: "Stat 3 Label" },
  { key: "stat4_value", label: "Stat 4 Value" },
  { key: "stat4_label", label: "Stat 4 Label" },
];

const HeroEditor = () => (
  <SingletonEditor
    resource="hero"
    title="Hero Section"
    eyebrow="Home Page"
    fields={fields}
    testIdPrefix="hero-edit"
  />
);
export default HeroEditor;
